import { EMOJI_GLYPHS, EMOJI_TONES, TONEABLE } from './emoji-data';

export const EMOJI_PREFIX = 'emoji:';

const TONE_SUFFIX_RE = /-tone([1-5])$/;

export function emojiShortcode(name: string): string {
	return name.slice(EMOJI_PREFIX.length).replace(TONE_SUFFIX_RE, '');
}

export const SKIN_TONE_VALUES = [0, 1, 2, 3, 4, 5] as const;
export type Tone = (typeof SKIN_TONE_VALUES)[number] | null;

const toneableSet: ReadonlySet<string> = new Set(TONEABLE);

export function isToneableShortcode(shortcode: string): boolean {
	return toneableSet.has(shortcode);
}

export function getTonedGlyph(shortcode: string, tone: Tone): string {
	if (tone === null || tone === 0) return EMOJI_GLYPHS[shortcode] ?? '';
	return EMOJI_TONES[shortcode]?.[tone - 1] ?? EMOJI_GLYPHS[shortcode] ?? '';
}

export function isEmojiName(name: string | undefined | null): name is string {
	return typeof name === 'string' && name.startsWith(EMOJI_PREFIX);
}

export function composeEmojiGlyph(name: string | undefined | null): string | null {
	if (!isEmojiName(name)) return null;

	const ref = name.slice(EMOJI_PREFIX.length);
	const toneMatch = ref.match(TONE_SUFFIX_RE);
	const shortcode = toneMatch ? ref.slice(0, toneMatch.index) : ref;

	if (!EMOJI_GLYPHS[shortcode]) return null;

	if (!toneMatch) return EMOJI_GLYPHS[shortcode];

	if (!isToneableShortcode(shortcode)) return null;

	const toneIndex = Number(toneMatch[1]);
	if (toneIndex < 1 || toneIndex > 5) return null;
	return getTonedGlyph(shortcode, toneIndex as Tone);
}
